import axios from "axios";
import { API_BASE } from "../../config/env";
/**APPLICATION START */
export const FETCH_LASTAPPLICATIONRESULT_FULFILLED = "FETCH_LASTAPPLICATIONRESULT_FULFILLED";
export const FETCH_LASTAPPLICATIONRESULT_REJECTED = "FETCH_LASTAPPLICATIONRESULT_REJECTED";
export const FETCH_LASTAPPLICATIONRESULT_PENDING = "FETCH_LASTAPPLICATIONRESULT_PENDING";
export const RESET_LASTAPPLICATIONRESULT = "RESET_LASTAPPLICATIONRESULT"


export function lastApplicationResult(applicationId) {

    const token = localStorage.getItem("accessToken")

    return (dispatch) => {
        dispatch({
            type: "FETCH_LASTAPPLICATIONRESULT",
            payload: axios({
                method: "GET",
                url: `${API_BASE}/api/v3/second-opinion/last-temporal-application-result?applicationId=${applicationId}`,
                headers: {
                    "Authorization": "Bearer " + token,
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("One-Id"),
                    "One-Id": localStorage.getItem("Client-Id"),
                    "Content-Type": "application/json",
                    "ngrok-skip-browser-warning" : "69920"
                },
            }).then((result) => result.data),
        });
    };
}

export function resetLastApplicationResult() {
    return (dispatch) => {
        dispatch({
            type: "RESET_LASTAPPLICATIONRESULT",
        });
    };
}


